module.exports = __webpack_public_path__ + "img/工单支撑-bg.00ce7a02.jpg";